import { errorMessage } from "helpers/utils";
import { call, put, takeEvery } from "redux-saga/effects";
import CurrencyManagerService from "services/CurrencyManagerService";
import {
  activeCurrencyManagerFail,
  activeCurrencyManagerSuccess,
  createCurrencyManagerFail,
  createCurrencyManagerSuccess,
  detailCurrencyManagerFail,
  detailCurrencyManagerSuccess,
  listCurrencyManagerFail,
  listCurrencyManagerSuccess,
  updateCurrencyManagerSuccess,
  updateCurrencyManagerFail,
} from "store/actions";
import { deleteCurrencyManagerFail, deleteCurrencyManagerSuccess } from "./actions";
import {
  CURRENCY_MANAGER_CREATE,
  CURRENCY_MANAGER_DETAIL,
  CURRENCY_MANAGER_LIST,
  CURRENCY_MANAGER_UPDATE,
  CURRENCY_MANAGER_DELETE
} from "./actionTypes";
function* fetchListCurrencyManager({ payload }) {
  try {
    const response = yield call(CurrencyManagerService.listCurrencyManager, payload);
    yield put(listCurrencyManagerSuccess(response));
  } catch (error) {
    yield put(listCurrencyManagerFail(errorMessage(error)));
  }
}

function* onUpdateCurrencyManager({ payload }) {
  try {
    const response = yield call(CurrencyManagerService.updateCurrencyManager, payload);
    yield put(updateCurrencyManagerSuccess(response));
  } catch (error) {
    yield put(updateCurrencyManagerFail(errorMessage(error)));
  }
}
function* onCreateCurrencyManager({ payload }) {
  try {
    const response = yield call(CurrencyManagerService.createCurrencyManager, payload);
    yield put(createCurrencyManagerSuccess(response));
  } catch (error) {
    yield put(createCurrencyManagerFail(errorMessage(error)));
  }
}

function* onDetailCurrencyManager({ payload }) {
  try {
    const response = yield call(CurrencyManagerService.detailCurrencyManager, payload);
    yield put(detailCurrencyManagerSuccess(response));
  } catch (error) {
    yield put(detailCurrencyManagerFail(errorMessage(error)));
  }
}

function* onDeleteCurrencyManager({ payload }) {
  try {
    const response = yield call(CurrencyManagerService.deleteCurrencyManager, payload);
    yield put(deleteCurrencyManagerSuccess(response));
  } catch (error) {
    yield put(deleteCurrencyManagerFail(errorMessage(error)));
  }
}

function* onActiveCurrencyManager({ payload }) {
  try {
    const response = yield call(CurrencyManagerService.activeCurrencyManager, payload);
    yield put(activeCurrencyManagerSuccess(response));
  } catch (error) {
    yield put(activeCurrencyManagerFail(errorMessage(error)));
  }
}

function* userManagementSaga() {
  yield takeEvery(CURRENCY_MANAGER_LIST, fetchListCurrencyManager);
  yield takeEvery(CURRENCY_MANAGER_CREATE, onCreateCurrencyManager);
  yield takeEvery(CURRENCY_MANAGER_DETAIL, onDetailCurrencyManager);
  yield takeEvery(CURRENCY_MANAGER_UPDATE, onUpdateCurrencyManager);
  yield takeEvery(CURRENCY_MANAGER_DELETE, onDeleteCurrencyManager);
}

export default userManagementSaga;
